import range from './range.js';

function monthListOptions() {
	return range(1, 12)
		.map(key => (String(key)).padStart(2, '0'));
}

export default monthListOptions;
